

define(['jquery', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/user/index', 'components/xo-ui-components/src/error-tooltip/directive'], function ($, squid, template) {

    squid.module('xo-add-tax-id.directive', ['squid', 'xomodel.checkout', 'xomodel.user', 'xo-error-tooltip.directive']).directive('xoAddTaxId', function () {
        return {
            scope: {
                token: '=',
                finish: '='
            },
            template: template,

            controller: function controller($scope, $populate, $state, $element, $CheckoutSessionModel, $UserInfoModel, $CheckoutCartModel) {

                function thenFunction() {
                    var taxIdType = 'CPF';
                    if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.cause === 'NEED_BUSINESS_TAX_INFO_TO_PAY') {
                        taxIdType = 'CNPJ';
                    }
                    var issuer = 'BR_' + taxIdType;
                    $scope.subType = taxIdType;

                    $scope.userInfo = $UserInfoModel.instance($scope.token);

                    $scope.onSubmit = function () {
                        // Scrub the formatting when invoking the backend services.
                        var unformatted = ($scope.taxId || '').replace(/[^0-9]+/g, '');
                        var data = {
                            newDocId: {
                                type: 'TAX_ID',
                                subType: $scope.subType,
                                issuerCountry: 'BR',
                                issuer: issuer,
                                value: unformatted,
                                collectionPoint: 'UNKNOWN',
                                placeOfIssue: 'BR'
                            }
                        };

                        $scope.userInfo.action('addTaxId', {
                            data: data,

                            success: function success() {
                                var checkoutSession = $CheckoutSessionModel.instance($scope.token);
                                var checkoutCart = $CheckoutCartModel.instance($scope.token);
                                return checkoutSession.action('create', {
                                    data: {
                                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                                    },
                                    success: function success() {
                                        // Clear the errors if create checkout session was successful
                                        $scope.checkoutSession.errorData = undefined;
                                        $scope.finish();
                                    }
                                });
                            },

                            validation: function validation(validationData) {
                                var $el = $($element);
                                var $field = $($el.find('[name="' + validationData.field + '"]'));
                                $field.addClass('backendError');
                                $field.attr('aria-invalid', true);
                                $field.focus();
                            }
                        });
                    };

                    $scope.changeTaxId = function (newValue) {
                        var unformatted = (newValue || '').replace(/[^0-9]+/g, '');
                        var formatted = '';
                        var i = 0;

                        // For CPF we will format the output with dots and dashes like this:
                        // 999.999.999-99
                        if ($scope.subType === 'CPF') {
                            for (i = 0; i < unformatted.length; i++) {
                                if (i === 3 || i === 6) {
                                    formatted = formatted + '.';
                                }
                                if (i === 9) {
                                    formatted = formatted + '-';
                                }
                                formatted = formatted + unformatted.charAt(i);
                            }
                            $scope.taxId = formatted;
                            // For CNPJ we will format the output with dots, dashes, and slashes like this:
                            // 99.999.999/9999-99
                        } else if ($scope.subType === 'CNPJ') {
                            for (i = 0; i < unformatted.length; i++) {
                                if (i === 2 || i === 5) {
                                    formatted = formatted + '.';
                                } else if (i === 8) {
                                    formatted = formatted + '/';
                                } else if (i === 12) {
                                    formatted = formatted + '-';
                                }
                                formatted = formatted + unformatted.charAt(i);
                            }
                            $scope.taxId = formatted;
                        } else {
                            $scope.taxId = unformatted;
                        }
                    };
                }

                $populate($scope, {
                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
                }).then(thenFunction());
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-form-components/src/add-tax-id/directive.js
 ** module id = 405
 ** module chunks = 1
 **/